export default "__VITE_ASSET__DZT$DKcz__"